/**
 * @fileoverview 全局接口
 */
import Url from 'c-url';
import native from 'c-up-native';
import user from 'c-up-login';
import Profile from '../component/profile/index';

let global = {
    urls: {
        home: '../uppro/index.html',
        living: '../uppro/index.html#/living/{roomid}/{uid}',
        profile: '../uppro/index.html#/profile/{uid}'
    },
    isDebug: !!(Url.query('debug')),

    goUpliveHome: function() {
        let url = this.urls.home;

        url = this.getAbsoluteUrl(url);

        if (window.__app_feature == '1001') {
            url = url.replace('uppro', 'ludouppro')
        }
        if (window.__app_feature == '1002') {
            url = url.replace('uppro', 'dominouppro')
        }

        location.href = url;
    },

    goUpliveLiving: function(roomid, uid) {
        
        let url = this.urls.living.replace('{roomid}', roomid).replace('{uid}', uid);

        if (Url.query('shareUid')) {
            url = Url.addParam(url, {
                shareUid: Url.query('shareUid'),
                sharePlatform: Url.query('sharePlatform')
            });
        }

        url = this.getAbsoluteUrl(url);
        
        location.href = url;
    },
    getProjectVersion() {
        const version = PROJECT_VERSION.split(".");
        version.splice(2, 0, "0");
        return version.join(".");
    },
    getGlobalUA() {
        // 市场渠道, 用于跟踪app端用户行为, 比如每天的充值消费
        let channel = 'h5minivideos';
        let feature = Url.query('feature') || 0;
        let arr = [];
        arr[arr.length] = 'H5/' + channel;
        arr[arr.length] = `version/${global.getProjectVersion()}`;
        arr[arr.length] = 'feature/'+feature;
        return arr.join(' ');
    },
    goUpliveProfile: function(uid) {
        let url = this.urls.profile.replace('{uid}', uid);

        url = this.getAbsoluteUrl(url);
        location.href = url;
    },

    getAbsoluteUrl: function(url) {
        var a = document.createElement('A');
        a.href = url;
        url = a.href;

        let obj = Url.parse(url);

        if (Url.query('env')) {
            url = Url.addParam(url, {
                env: Url.query('env')
            });
        }
        if (obj.host == 'h5.upliveapp.com') {
            url = Url.addParam(url, {
                td_channelid: 'uplive_minivedios',
                clientType: 'h5uplive_from_minivedios'
            });
        } else {
            url = Url.addParam(url, {
                ga_channel: 'uplive_minivedios',
                clientType: 'h5uplive_from_minivedios'
            });
        }

        return url;
    },

    getLoginUserProfile(success, fail) {
        let user = this.getUser();
        let failCount = 0;

        let getUserProfile = () => {
            let promise = new Profile(user.uid).promise;
            
            promise.done((msg) => {
                success(msg);
                if ($.isLoginedProps === 1) {
                    $.isLoginedProps = 0;
                }
                
            }).fail(() => {
                failCount++;
                if (failCount == 3) {
                    fail();
                } else {
                    getUserProfile();
                }

            });
        };

        getUserProfile();

    },

    // 获取用户登录标示
    getUser: function() {
        return user.getUser();
    },

    // 登录
    login: function(backurl, lang) {
        user.login(backurl, lang);
    }
};

export default global;



// WEBPACK FOOTER //
// ./js/base/global.js